import React from "react";
import CTAPage from "./CTAPage";

const PartnerWithUs = () => (
  <CTAPage
    eyebrow="Partner With Us"
    title="Grow with India's trusted home-care brand"
    subtitle="Are you a hospital, clinic, doctor, diagnostic lab or care agency? Partner with Healthsqur to extend premium home healthcare to your patients — backed by verified caregivers, a dedicated care manager and seamless coordination."
    image="/generated/partner_hero.png"
    highlights={[
      "Referral & revenue-sharing partnerships",
      "Verified, trained caregiver network",
      "Seamless discharge-to-home coordination",
      "Co-branded, patient-first care",
    ]}
    formProps={{
      heading: "Become a partner",
      subheading: "Tell us about your organisation and how you'd like to work together.",
      category: "Partnership",
      extraLabel: "Partnership type",
      extraOptions: [
        "Hospital / Clinic",
        "Doctor / Consultant",
        "Physiotherapist",
        "Diagnostic Lab",
        "Pharmacy",
        "Medical Equipment Supplier",
        "Care Agency",
        "Corporate / Insurance",
        "Other",
      ],
      submitLabel: "Submit Partnership Enquiry",
    }}
  />
);

export default PartnerWithUs;
